<template>
  <div v-if="item.tags" class="tagList" :style="{ width: tagsListWidth }">
    <wa-badge v-if="item.productStatus !== 'ACTIVE'" variant="brand" class="badgeSparePart">{{
      $t(`productStatus.${item.productStatus}`)
    }}</wa-badge>
    <template v-else>
      <wa-badge v-if="item.tags.includes('New In')" variant="brand" class="badgeNew">New</wa-badge>
      <wa-badge v-if="item.tags.includes('Sustainable')" variant="brand" class="badgeSustainable"
        >Acetate Renew</wa-badge
      >
      <wa-badge v-if="item.tags.includes('Top Pick')" variant="brand" class="badgeTopPick">{{
        $t('product.badges.topPick')
      }}</wa-badge>
      <wa-badge v-if="item.productStatus === 'COMING_SOON'" variant="brand" class="badgeCommingSoon"
        >Coming soon</wa-badge
      >
    </template>
    <wa-badge
      v-if="
        deviceStore.settings.warehouse === stockLocation &&
        handoverPossible &&
        deviceStore.settings.stockLocationId !== deviceStore.settings.serviceHubId
      "
      variant="brand"
      class="badgeHandover"
      >{{ $t('globals.handover') }}</wa-badge
    >
    <wa-badge v-if="assemblyInServicehub" variant="brand" class="">{{
      $t('globals.assemplyInSH')
    }}</wa-badge>
    <wa-badge
      v-if="
        item?.price.default[deviceStore.settings.country]?.compareAt !==
        item?.price.default[deviceStore.settings.country]?.price
      "
      variant="brand"
      class="badgeSale"
      >Sale</wa-badge
    >
  </div>
</template>

<script setup>
import '@awesome.me/webawesome/dist/components/tag/tag.js'
import { useDeviceStore } from '@/stores/device'

const deviceStore = useDeviceStore()

defineProps({
  item: {
    type: Object,
    default: () => ({})
  },
  stockLocation: {
    type: String,
    default: ''
  },
  isSparePart: {
    type: Boolean,
    default: false
  },
  handoverPossible: {
    type: Boolean,
    default: true
  },
  assemblyInServicehub: {
    type: Boolean,
    default: false
  },
  tagsListWidth: {
    type: String,
    default: '214px'
  }
})
</script>

<style scoped lang="postcss">
.tagList {
  .configurator__image & {
    width: 100%;
  }

  wa-badge + wa-badge {
    margin-left: 0.5rem;
  }
}
</style>
